(ns dashboard.events.rooms
  (:require
   [re-frame.core :as re-frame]
   [graphql-query.core :refer [graphql-query]]
   [dashboard.utils :refer [graphql-request-format index-of ->json]]
   [dashboard.interceptors :refer [standard-interceptors]]
   [dashboard.config :as config]
   [ajax.core :as ajax]))

;;------------------------
;; Rooms

(def room-fields
  [:id :name :nameJp :organizationId :eventId :color :type :description :geometry])

;; Create Room

(defn create-room-query
  [{:keys [room]}]
  {:operation {:operation/type :mutation
               :operation/name :addRoom}
   :queries [[:addRoom
              (-> room
                  (assoc :geometry (->json (:geometry room))))
              room-fields]]})

(re-frame/reg-event-fx
 ::create-room
 standard-interceptors
 (fn [{:keys [db]} [{:keys [room]}]]
   {:graphql-request {:query (graphql-query (create-room-query {:room room}))
                      :on-success [::create-room-success]}}))

(re-frame/reg-event-fx
 ::create-room-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error Creating Room"
       :intent :intent/danger
       :duration 10000
       :message (clojure.string/join "\n" (map :message (:errors res)))}}
     {:show-notification!
      {:title "Room Created"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly created " (:name (get-in res [:data :addRoom])))}
      :dispatch [::add-room (get-in res [:data :addRoom])]})))

;; Update Room

(defn update-room-query
  [{:keys [room]}]
  {:operation {:operation/type :mutation
               :operation/name :updateRoom}
   :queries [[:updateRoom
              (-> room
                  (dissoc :organizationId :eventId :created)
                  (assoc :geometry (->json (:geometry room))))
              room-fields]]})

(re-frame/reg-event-fx
 ::update-room
 standard-interceptors
 (fn [{:keys [db]} [{:keys [room]}]]
   {:graphql-request {:query (graphql-query (update-room-query {:room room}))
                      :on-success [::update-room-success]}}))

(re-frame/reg-event-fx
 ::update-room-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error Updating Room"
       :intent :intent/danger
       :duration 10000
       :message (clojure.string/join "\n" (map :message (:errors res)))}}
     {:show-notification!
      {:title "Room Updated"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly updated the room "
                     (:name (get-in res [:data :updateRoom])))}
      :dispatch [::edit-room (get-in res [:data :updateRoom])]})))

;; Create Room

(defn delete-room-query
  [{:keys [room]}]
  {:operation {:operation/type :mutation
               :operation/name :deleteRoom}
   :queries [[:deleteRoom
              {:id (:id room)}
              room-fields]]})

(re-frame/reg-event-fx
 ::delete-room
 standard-interceptors
 (fn [{:keys [db]} [{:keys [room]}]]
   {:graphql-request {:query (graphql-query (delete-room-query {:room room}))
                      :variables {}
                      :on-success [::delete-room-success]}}))

(re-frame/reg-event-fx
 ::delete-room-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error Deleting Room"
       :intent :intent/danger
       :duration 10000
       :message (clojure.string/join "\n" (map :message (:errors res)))}}
     {:show-notification!
      {:title "Room Deleted"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly deleted " (:name (get-in res [:data :deleteRoom])))}
      :dispatch [::remove-room (get-in res [:data :deleteRoom])]})))

;; Add a room to the list of events in the application db
(re-frame/reg-event-db
 ::add-room
 standard-interceptors
 (fn [db [room]]
   (update-in db [:event-organizer/rooms] conj room)))

;; Edit a room to the list of events in the application db
(re-frame/reg-event-db
 ::edit-room
 standard-interceptors
 (fn [db [room]]
   (let [room-idx (index-of (map :id (:event-organizer/rooms db)) (:id room))]
     (update-in db [:event-organizer/rooms room-idx] merge room))))

;; Remove a room from the list of events in the application db
(re-frame/reg-event-db
 ::remove-room
 standard-interceptors
 (fn [db [room]]
   (let [old-rooms (:event-organizer/rooms db)
         new-rooms (into [] (filter #(not= (:id %) (:id room)) old-rooms))]
     (assoc db :event-organizer/rooms new-rooms))))

;; List Rooms

(defn list-rooms-by-event-query
  [{:keys [event-id]}]
  {:operation {:operation/type :query
               :operation/name :allRoomsByEvent}
   :queries [[:allRoomsByEvent
              {:eventId event-id}
              {:rooms room-fields}]]})

(re-frame/reg-event-fx
 ::list-rooms-by-event
 standard-interceptors
 (fn [{:keys [db]} [{:keys [event-id]}]]
   (let [event-id (or event-id
                      (get-in db [:event-organizer/selected :event-id]))]
     {:graphql-request {:query (graphql-query (list-rooms-by-event-query {:event-id event-id}))
                        :on-success [::list-rooms-by-event-success]}})))

(re-frame/reg-event-fx
 ::list-rooms-by-event-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   {:db (assoc db :event-organizer/rooms (get-in res [:data :allRoomsByEvent :rooms]))}))
